import { createSelector } from "@ngrx/store";

import * as fromFeature from "../reducers";
import * as fromAssignSettings from "../reducers/assign-settings.reducer";

export const getAssignSettingsState = createSelector(
    fromFeature.getAssignModuleState,
    (state: fromFeature.AssignState) => state.assignSettings
);

export const getGlobalDateSettings = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getGlobalDateSettings
);

export const getGlobalAutoProgress = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getGlobalAutoProgress
);

export const getAutoProgressAssignables = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getAutoProgressAssignables
);

export const getGlobalMaxAttempts = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getGlobalMaxAttempts
);

export const getGlobalLanguageOptions = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getGlobalLanguageOptions
);

export const getMaxAttemptsAssignables = createSelector(
    getAssignSettingsState,
    fromAssignSettings.getMaxAttemptsAssignables
);
